<template>
  <div>
    <full-loading :value="loading"></full-loading>
    <v-navigation-drawer
      width="275"
      :mini-variant="settings.miniVariant"
      v-model="settings.drawer"
      app
      dark
      color="blueviolet"
      class="cabinet-sidebar">
      <div class="d-flex align-center px-2 justify-center logo-div" :style="{height: settings.toolbarHeight-2 + 'px'}">
        <div class="logo-img" v-if="!settings.miniVariant">
          <img src="../assets/images/logo.png" alt="">
        </div>
      </div>
      <v-divider/>
      <navigation/>

      <v-btn absolute bottom right icon @click="settings.miniVariant = !settings.miniVariant">
        <v-icon>{{ settings.miniVariant ? 'fas fa-caret-right' : 'fas fa-caret-left' }}</v-icon>
      </v-btn>

      <a v-show="!settings.miniVariant" href="tel:+998939825001" style="color: #ffffff; position: absolute; bottom: 60px; white-space: nowrap; left: 15px" class="text-decoration-none">По вопросом: +998 93 982 5001</a>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="light"
      :height="settings.toolbarHeight"
      class="justify-end"
      flat>
      <v-btn icon @click.stop="settings.drawer = !settings.drawer"
             :class="['menu-drawer-activator', {'menu-drawer-activator-active': !settings.drawer}]">
        <svg width="25" height="25" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
		<path
      d="M467,61H165c-24.82,0-45,20.19-45,45c0,24.82,20.18,45,45,45h302c24.81,0,45-20.18,45-45C512,81.19,491.81,61,467,61z"/>
          <path d="M467,211H165c-24.82,0-45,20.19-45,45c0,24.82,20.18,45,45,45h302c24.81,0,45-20.18,45-45C512,231.19,491.81,211,467,211z
			"/>
          <path d="M467,361H165c-24.82,0-45,20.19-45,45c0,24.82,20.18,45,45,45h302c24.81,0,45-20.18,45-45C512,381.19,491.81,361,467,361z
			"/>
          <path
            d="M45,61C20.18,61,0,81.19,0,106c0,24.82,20.18,45,45,45c24.81,0,45-20.18,45-45C90,81.19,69.81,61,45,61z"/>
          <path
            d="M45,211c-24.82,0-45,20.19-45,45c0,24.82,20.18,45,45,45c24.81,0,45-20.18,45-45C90,231.19,69.81,211,45,211z"/>
          <path
            d="M45,361c-24.82,0-45,20.19-45,45c0,24.82,20.18,45,45,45c24.81,0,45-20.18,45-45C90,381.19,69.81,361,45,361z"/>
</svg>
      </v-btn>
      <v-spacer/>
      <div class="d-flex">
        <span class="d-inline-block mr-2">{{theme}}</span>
        <v-switch
          v-model="$vuetify.theme.isDark"
          @change="changeTheme"
          hide-details
        ></v-switch>
      </div>
      <v-menu>

        <template v-slot:activator="{ on, attrs }">
          <v-list
            dense
            class="py-0">
            <v-list-item
              :ripple="false" two-line class="px-0 justify-end " @click="on.click">
              <v-list-item-avatar
                height="30"
                width="30"
              >
                <img :src="mko ? mko.logo_url : userIcon">
              </v-list-item-avatar>
              <v-list-item-content v-if="me">
                <v-list-item-subtitle>{{me.email}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <v-list>
          <v-list-item @click="logOut">
            <v-list-item-title>Выйти</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <div class="pa-xl-7 px-3 pt-5">
        <router-view/>
      </div>
    </v-main>
    <up-down-navigation/>

  </div>
</template>

<script>
    import FullLoading from "@/components/ui/loading/full-loading"
    import Navigation from "@/layouts/Navigation";
    import TokenService from "@/utils/TokenService";
    import router from "@/router";
    import {mapGetters} from 'vuex'
    import {setThemeToLocalStorage} from "@/utils/pureFunctions";
    import {THEMES} from "@/utils/constants";
    import UpDownNavigation from "@/components/ui/up-down-navigation/UpDownNavigation";

    export default {
        name: "MainLayout",
        components: {UpDownNavigation, FullLoading, Navigation},
        data() {
            return {
                userIcon: require('../assets/images/user.png'),
                settings: {
                    toolbarHeight: 64,
                    miniVariant: false,
                    drawer: true
                },
                currentUserAction: null,
            }
        },

        computed: {
            theme() {
                return THEMES[this.$vuetify.theme.isDark ? 'dark' : 'light']
            },
            ...mapGetters(['mko', 'me']),
            loading() {
                return this.$store.getters.loading
            }
        },
        methods: {
            changeTheme(isDark) {
                setThemeToLocalStorage(isDark ? 'dark' : 'light')
            },
            logOut() {
                TokenService.removeToken()
                this.$store.commit('clearUser')
                router.push({name: 'login'})
            }
        },
      created() {
          if(this.$vuetify.breakpoint.mobile) {
            this.settings.drawer = false
          }
      },
        beforeDestroy() {
            this.$store.dispatch('clearTimeIntervalRefreshToken')
        }
    }
</script>

<style scoped>
  .logo-div {
    background-color: #f5f5f5;
  }
</style>
